<template>
  <div class="options-container">
    <div
      v-for="(option, index) in options"
      v-bind:key="index"
      class="option-box p-3 mb-2 fs-6"
      :class="{ selected: selectedOption === index }"
      @click="handleOptionClick(index)"
    >
      {{ option }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "OptionsSelector",
  props: {
    options: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  emits: ["onChange"],
  setup() {
    const selectedOption = ref<number | null>(null);
    return {
      selectedOption,
    };
  },
  methods: {
    handleOptionClick(index: number) {
      this.selectedOption = index;
      const value = this.options[index];
      this.$emit("onChange", { index, value });
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
.options-container {
  display: flex;
  flex-direction: column;
}
.option-box {
  border: 1px solid $pj-color-light-gray;
  border-radius: 10px;
  font-size: 15px;
  color: $pj-color-black;
  &.selected {
    border: 1px solid $pj-color-green-cell;
    background-color: $pj-color-green-hover;
  }
}
</style>
